var map = {
	"./de": [
		"./src/i18n/locales/de.js",
		"hops-language-de"
	],
	"./de.js": [
		"./src/i18n/locales/de.js",
		"hops-language-de"
	],
	"./en": [
		"./src/i18n/locales/en.js",
		"hops-language-en"
	],
	"./en.js": [
		"./src/i18n/locales/en.js",
		"hops-language-en"
	],
	"./es": [
		"./src/i18n/locales/es.js",
		"hops-language-es"
	],
	"./es.js": [
		"./src/i18n/locales/es.js",
		"hops-language-es"
	],
	"./fr": [
		"./src/i18n/locales/fr.js",
		"hops-language-fr"
	],
	"./fr.js": [
		"./src/i18n/locales/fr.js",
		"hops-language-fr"
	],
	"./it": [
		"./src/i18n/locales/it.js",
		"hops-language-it"
	],
	"./it.js": [
		"./src/i18n/locales/it.js",
		"hops-language-it"
	],
	"./ru": [
		"./src/i18n/locales/ru.js",
		"hops-language-ru"
	],
	"./ru.js": [
		"./src/i18n/locales/ru.js",
		"hops-language-ru"
	],
	"./tr": [
		"./src/i18n/locales/tr.js",
		"hops-language-tr"
	],
	"./tr.js": [
		"./src/i18n/locales/tr.js",
		"hops-language-tr"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/i18n/locales lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;